module.exports = __webpack_public_path__ + "assets/img/IMG003.940d935c.png";